import { ReactComponent as OverflowImg } from "src/assets/images/Overflow.svg";
import styled from "styled-components";

interface Props {
  // We shouldn't use any, but this thing is overloaded to hell.
  onClick?: any;
}

export const OverflowIcon = styled(OverflowImg)<Props>`
  height: 24px;
  width: 24px;
  opacity: 0.25;

  &:active {
    opacity: 1;
  }
`;
